/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCrop169Filled = createReactComponent("filled", "crop-16-9-filled", "IconCrop169Filled", [["path", { "d": "M18 7a3 3 0 0 1 3 3v4a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-4a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

export { IconCrop169Filled as default };
//# sourceMappingURL=IconCrop169Filled.mjs.map
